var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06022 16.9453C9.03049 17.0642 9.01562 17.1683 9.01562 17.3021C9.01562 18.0602 9.63998 18.6846 10.3981 18.6846C11.1563 18.6846 11.7806 18.0602 11.7806 17.3021C11.7806 17.1832 11.7658 17.0642 11.736 16.9453H9.06022Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9415 15.6989C15.9266 15.5799 15.882 15.4759 15.8077 15.3867C15.7928 15.3718 14.6036 14.0785 14.6036 10.6594C14.6036 7.99851 12.8197 6.88359 11.348 6.54168V5.76867C11.348 5.21865 10.8872 4.75781 10.3372 4.75781C9.78715 4.75781 9.31145 5.21865 9.31145 5.76867V6.55655C7.83976 6.89845 6.05589 7.99851 6.05589 10.6743C6.05589 14.0934 4.86665 15.3867 4.85178 15.3867C4.76259 15.4759 4.71799 15.5799 4.70312 15.6989V16.6354H15.9415V15.6989Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53394 12.2623C2.35669 8.80374 4.20609 5.04565 7.66468 3.8684",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71248 12.6185C1.36328 8.65469 3.48281 4.34766 7.44659 2.99845",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44915 11.9492C3.67529 8.52235 4.83561 6.1645 7.97652 4.78132",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 12.2623C18.1824 8.80374 16.333 5.04565 12.8744 3.8684",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8266 12.6185C19.1758 8.65469 17.0563 4.34766 13.0925 2.99845",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0899 11.9492C16.8638 8.52235 15.7035 6.1645 12.5625 4.78132",
    fill: "none",
    strokeWidth: 0.445967,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBellIcon);
export default __webpack_public_path__ + "static/media/calendarBellIcon.87281b5544211769b158e4b6fbeabab8.svg";
export { ForwardRef as ReactComponent };